import * as React from 'react';

import { Modal } from '@creditornot/cbt-modal';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

import { RecentlyAddedItems } from './RecentlyAddedItems';

export const RecentlyAddedItemsDrawer: React.FC<{
  isVisible: boolean;
  onDismiss: () => void;
  selectedWarehouseId: string;
}> = ({ isVisible, onDismiss, selectedWarehouseId }) => {
  const formatMessage = useFormatMessage();

  return (
    <Modal
      disableContentPadding
      open={isVisible}
      onDismiss={onDismiss}
      sizePreset={{ mobile: 'bottomSheet:stretched', desktop: 'sideEndSheet:medium' }}
      title={formatMessage('receiving.recently_added')}
    >
      <RecentlyAddedItems selectedWarehouseId={selectedWarehouseId} />
    </Modal>
  );
};
